import { useEffect } from 'react';

import { Button, FormControl, FormLabel, Input, Text } from '@chakra-ui/react';

import Modal from '../../../components/shared/Modal';

type CreateProviderModalProps = {
  isOpen: boolean;
  onClose: () => void;
  providerName: string;
  setProviderName: (name: string) => void;
  providerSlug: string;
  setProviderSlug: (slug: string) => void;
  handleCreateProvider: () => Promise<void>;
  createProviderLoading: boolean;
};

const CreateProviderModal = ({
  isOpen,
  onClose,
  providerName,
  setProviderName,
  providerSlug,
  setProviderSlug,
  handleCreateProvider,
  createProviderLoading,
}: CreateProviderModalProps) => {
  // Generate slug automatically when provider name changes
  useEffect(() => {
    if (providerName) {
      const generatedSlug = providerName.toLowerCase().replace(/\s+/g, '-');
      setProviderSlug(generatedSlug);
    }
  }, [providerName, setProviderSlug]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create Affiliate Provider"
      rightButtons={
        <>
          <Button
            colorScheme="green"
            mr={3}
            onClick={handleCreateProvider}
            isLoading={createProviderLoading}
          >
            Create
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </>
      }
    >
      <FormControl mb={4}>
        <FormLabel>Provider Name</FormLabel>
        <Input
          value={providerName}
          onChange={(e) => setProviderName(e.target.value)}
          placeholder="Enter provider name"
        />
      </FormControl>

      {providerSlug && (
        <FormControl>
          <FormLabel>Provider Slug (auto-generated)</FormLabel>
          <Text fontSize="md" mt={1}>
            {providerSlug}
          </Text>
          <Text fontSize="sm" color="gray.500" mt={1}>
            Automatically generated from provider name using lowercase letters with dashes
          </Text>
        </FormControl>
      )}
    </Modal>
  );
};

export default CreateProviderModal;
